<template>
    <div id="div-main">
        <b-row v-if="!requestJobs" align-v="center" class="m-4 p-2">
            <b-col/>
            <div align-h="center">
                <h3 class="mb-3 pb-3">Lädt...</h3>
                <b-spinner style="width: 4rem; height: 4rem;" label="loading..."/>
            </div>
            <b-col/>
        </b-row>
        <div v-else>
            <div class="row" id="coi-pagination">
                <div class="col-md-2">
                    <div class="d-flex justify-content-start">
                    <h3>Request Job Resolver</h3>
                    </div>
                </div>
                <div class="col-md-10">
                    <div class="d-flex flex-row justify-content-end">
                    <div class="d-flex flex-row-reverse">

                        <div class="pl-2 py-2">
                            <b-button size="md" @click="filterByVendor()">filter</b-button>
                        </div>
                        <div class="py-2">
                            <b-form-select
                                id="per-page-select"
                                v-model="vendorId"
                                :options="vendorOptions"
                                size="md"
                            ></b-form-select>
                        </div>

                        <div class="py-2 pr-2">
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                                size="md"
                            ></b-form-select>
                        </div>
                        <div class="p-2">
                            <b-pagination
                                v-if="requestJobs"
                                v-model="currentPage"
                                :total-rows="requestJobs.length"
                                :per-page="perPage"
                                aria-controls="table-request-job"
                            ></b-pagination>
                        </div>
                    </div>
                    </div>
                </div>
            </div>

            <b-table
                id="table-request-job"
                v-if="requestJobs"
                :items="requestJobs"
                :per-page="perPage"
                :current-page="currentPage"
                :fields="fields"
                small
            ><!-- table -->
                <template v-slot:cell(ean)="row">
                    <span style="color:gray">{{row.item.ean}}</span>
                </template>
                <template v-slot:cell(actions)="row" _variant="danger">
                    <b v-if="row.item.manualAsin" class="float-right">{{row.item.manualAsin}}</b>
                    <b-button
                        v-else
                        size="sm" variant="primary"
                        v-b-modal.modal-resolve-asin
                        @click="resolve(row.item)"
                        class="mr-1 float-right"
                    ><!-- b-button -->
                        <span class="icon icon-pencil"/>
                    </b-button>
                </template>
            </b-table>
        </div>

        <b-modal
            id="modal-resolve-asin"
            title="ASIN auswählen"
            no-close-on-backdrop
            :size="(modalResolveAsin.isFullscreen) ? 'xl' :'md'"
            cancel-title="Abbrechen"
            @ok="modalResolveAsin.submit()"
            @cancel="modalResolveAsin.reset()"
        ><!-- modal -->
         <div slot="modal-header" class="d-flex align-items-center w-100">
            <h3 class="pl-3 pb-0 mb-0 mr-auto">ASIN auswählen</h3>
            <b-button
                class="d-flex justify-content-end mx-1"
                variant="secondary-outline"
                @click="modalResolveAsin.toggleFullscreen()"
                ><!-- button -->
                <span v-if="modalResolveAsin.isFullscreen" class="icon icon-shrink" />
                <span v-else                               class="icon icon-enlarge"/>
            </b-button>
               <b-button
                  class="close ml-0 mr-1 pr-1"
                  variant="secondary-outline"
                  @click="$bvModal.hide('modal-resolve-asin'); modalResolveAsin.reset()"
               >×</b-button>
         </div>

            <div v-if="modalResolveAsin.requestJob && modalResolveAsin.requestJob.title">
<!--              {{console.log(modalResolveAsin.requestJob)}}-->
                <span>Händler-Produkttitel ({{vendors.find( v => v.id == vendorId)?.name}}):</span>
                <h4>{{modalResolveAsin.requestJob.title}}</h4>
            </div>
            <b-table
                v-if="modalResolveAsin.requestJob"
                id="table-resolve-asin"
                :items="modalResolveAsinArrayItems"
                :fields="modalResolveAsin.fields"
                small
            ><!-- table -->
                <template v-slot:cell(asin)="row">
                    <b-button
                        v-if="row.item !== 'keine'"
                        block
                        size="sm"
                        @click="modalResolveAsin.selectAsin(row.item[0].asin.toUpperCase())"
                        :variant="modalResolveAsin.resolveButtonVariant(row.item[0].asin.toUpperCase())"
                    ><!-- button -->
                        <b>{{row.item[0].asin.toUpperCase()}}</b>
                    </b-button>
                    <b-button
                        v-else
                        block
                        :variant="( modalResolveAsin.requestJob && modalResolveAsin.requestJob.manualAsin && (row.item.asin === modalResolveAsin.requestJob.manualAsin)) ? 'info' : 'outline-info'"
                        @click="modalResolveAsin.selectAsin(row.item)"
                        size="sm"
                    >keine</b-button>
                </template>

                <template v-slot:cell(market)="row">
                  <div  v-if="row.item != 'keine'">
                    <b-button
                        v-for="(item, i) in row.item"
                        :key="i"
                        pill
                        size="sm"
                        @click="openInNewTab(`${marketLinks[item.market.id]}/dp/${item.asin.toUpperCase()}`)"
                        class="m-1"
                    ><!-- button -->
                      <!--                        {{markets.find( m => m.id == row.item.market.id).name.substr(7,2)}}-->
                      {{item.market.name.slice(-2)}}
                    </b-button>
                    <b-button
                        v-if="row.item && (row.item.length > 1)"
                        @click="openAllMarketsInNewTab(row.item[0].asin.toUpperCase())"
                        pill variant="outline-primary" size="sm" class="m-1"
                    >alle</b-button>
                  </div>
                </template>
            </b-table>
        </b-modal>

        <b-modal
            id="modal-eingabefehler"
            title="Eingabefehler"
            ok-only
            @hidden="$bvModal.show('modal-resolve-asin')"
        ><!-- modal -->
            <p class="my-4">Sie müssen eine ASIN auswählen, bevor Sie auf <b-button disabled size="sm" variant="primary">OK</b-button> klicken. Alternative können Sie die Auswahl mit dem Knopf <b-button disabled size="sm">Abbrechen</b-button> abbrechen.</p>
        </b-modal>

    </div>
</template>
<style>
    .modal-xl {
        max-width: 98% !important;
        min-width: 98% !important;
    }

</style>
<script>
import axios from 'axios'
export default {
    name: 'requestJobResolver',
    data() {
        return {
            requestJobs: null,
            markets: null,
            currentPage: 1,
            perPage: 100,
            pageOptions: [25, 100, 250, 1000],
            vendors: null,
            vendorId: 63,
           
            fields: [
                { key: 'identifier', label: 'EAN', sortable: true },
                {
                   key: 'createdAt',
                   label: 'Erstellt am',
                   formatter: (s) => (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '-',
                   sortable: true,
                },
                { key: 'actions', label: '' }
            ],
            modalResolveAsin: {
                piss: this,
                isFullscreen: false,
                error: null,
                requestJob: null,
                asins: [],
                asinToMarkets: null,
                fields: [
                    { key: 'asin', label: 'ASIN' },
                    { key: 'market', label: 'Marktplatz' }
                ],
                toggleFullscreen() { this.isFullscreen = !this.isFullscreen },
                selectAsin(asin) { this.requestJob.manualAsin = asin.toUpperCase() },
                submit()
                {
                    if(this.requestJob.manualAsin === null) {
                        this.piss.$bvModal.show('modal-eingabefehler');
                    } else if(this.requestJob.manualAsin.toUpperCase() === 'KEINE') {
                        this.requestJob.manualAsin = null;
                        this.requestJob.asin = null;
                        this.requestJob.state = 'finished';
                        this.requestJob.errorCode = 1547725108;
                        axios.put('/mds/request_job', this.requestJob).then( response => {
                            this.requestJob.manualAsin = 'KEINE';
                            let oldRequestJob = this.piss.requestJobs.find( rj => rj.id === this.requestJob.id );
                            oldRequestJob = this.requestJob;
                            this.requestJob = null;
                        }).catch( error => {
                            alert('Netzwerkfehler. Laden Sie die Seite bitte mit der F5 Taste sofort neu. Gehen Sie davon aus, dass alle ihre Änderungen verlorengegangen sind.');
                            console.error(error);
                        });
                    } else {
                        this.requestJob.state = 'manual_asin_set';
                        this.requestJob.asin = null;
                        this.requestJob.errorCode = 1366617151;
                        axios.put('/mds/request_job', this.requestJob).then( response => {
                            let oldRequestJob = this.piss.requestJobs.find( rj => rj.id === this.requestJob.id );
                            oldRequestJob = this.requestJob;
                            this.requestJob = null;
                        }).catch( error => {
                            alert('Netzwerkfehler. Laden Sie die Seite bitte mit der F5 Taste sofort neu. Gehen Sie davon aus, dass alle ihre Änderungen verlorengegangen sind.');
                            console.error(error);
                        });
                    }

                },
                reset()
                {
                    this.requestJob.manualAsin = null;
                    this.requestJob = null;
                },
                resolveButtonVariant(selectedAsin)
                {
                    if(selectedAsin === 'keine') return ( requestJob.manualAsin === 'keine' ) ? 'info' : 'info-outline';

                    return (( this.requestJob && this.requestJob.manualAsin
                         && (selectedAsin === this.requestJob.manualAsin))
                    ) ? 'primary' : 'secondary';
                }

            },
            marketLinks: { //TODO modify the fucking market table
                1: "https://www.amazon.com",
                2: "https://www.amazon.ca",
                3: "https://www.amazon.com.au",
                4: "https://www.amazon.co.jp",
                5: "https://www.amazon.de",
                6: "https://www.amazon.fr",
                7: "https://www.amazon.nl",
                8: "https://www.amazon.es",
                9: "https://www.amazon.it",
               10: "https://www.amazon.com.tr",
               11: "https://www.amazon.co.uk",
               22: "https://www.amazon.com.mx",
               23: "https://www.amazon.ae",
               24: "https://www.amazon.com.br",
               25: "https://www.amazon.sg",
               26: "https://www.amazon.se"
            }
        }
    },
    computed: {
      vendorOptions: function() {
        if(!this.vendors) return [{ text: "Haendler", value: null }];
        let ret = this.vendors.map( v => { return { text: v.name, value: v.id } });
        ret.unshift({ text: "---", value: null });
        return ret;
      },
      modalResolveAsinArrayItems: function() {
        if (this.modalResolveAsin.asinToMarkets == null) return [];
        console.log(this.modalResolveAsin.asinToMarkets);
        const arrayItems = Object.values(this.modalResolveAsin.asinToMarkets)
        console.log(arrayItems);
        return arrayItems
      }
    },
    methods: {
        openAllMarketsInNewTab(asin) {
          const asinCandidate = asin;
          let urls = [];
          this.modalResolveAsin.asinToMarkets[asinCandidate]
            .forEach( ac => Object.keys(ac).forEach(market => {
              if(urls.includes(`${this.marketLinks[ac.market.id]}/dp/${asinCandidate.toUpperCase()}`)) return;
            urls.push(`${this.marketLinks[ac.market.id]}/dp/${asinCandidate.toUpperCase()}`)
              }    //ac asinCandidate
        ));
            this.synch.openMultipleTabs(
                urls
            );
        },
        filterByVendor() {
            this.requestJobs = null;
            ((this.vendorId) ? axios.post('mds/filter_by_vendor_and_action_required', { vendorId: this.vendorId })
                             : axios.get ('/mds/request_job/by_state/action_required')
            ).then( response => {
              // console.log(response);
                this.currentPage = 1;
                this.requestJobs = response.data;
            }).catch(error => {
                console.error(error);
            });

        },
        resolve(requestJob)
        {
          // console.log(requestJob);
            this.modalResolveAsin.requestJob = requestJob;
            axios.get(`/mds/request_job/ambiguous_asin/${requestJob.identifier}`).then( response => {
              console.log(response);

              this.modalResolveAsin.asinToMarkets = {};

              //looping over the asinCandidates
              for(const asin of Object.keys(response.data)) {
                //looping over the marketplaces for a candidate
                const candidates = [];
                for (const candidate of response.data[asin]){
                    // check if that current asin is the same as this.modalResolveAsin.asinToMarkets[asin]

                    let candidate_ = {};
                    candidate_.asin = asin;
                    candidate_.market = this.markets.find(m => m.identifier ==  candidate.marketIdentifier);
                    candidates.push(candidate_);

                    if( this.modalResolveAsin.asinToMarkets?.[asin] && candidates.includes(c => c?.asin === asin ) ) {
                    }

                  }
                this.modalResolveAsin.asinToMarkets[asin] = candidates;
              }
              this.modalResolveAsin.asinToMarkets['keine'] = "keine";
              this.modalResolveAsin.asins = Object.keys(this.modalResolveAsin.asinToMarkets);
              console.log(this.modalResolveAsin.asinToMarkets);
            }).catch( error => {
                alert("Netzwerkfehler. Laden Sie die Seite bitte mit der F5 Taste sofort neu. Gehen Sie davon aus, dass alle ihre Änderungen verlorengegangen sind.");
                //$bvModal.hide('modal-resolve-asin')
                console.error(error);
            });
        },
        openInNewTab(url)
        {
            window.open(url, "_blank").focus();
        }
    },
    created()
    {
        Promise.all([
           axios.get('/mds/request_job/by_state/action_required')
         , axios.get('/mds/market')
         , axios.get('/vendor/all')
        ]).then( ([actionRequiredResponse, marketResponse, vendorResponse]) => {
          console.log(actionRequiredResponse);
            this.requestJobs = actionRequiredResponse.data;
            this.vendors = vendorResponse.data;
            this.markets = marketResponse.data;
        }).catch( error => {
            alert("Netzwerkfehler. Laden Sie die Seite bitte mit der F5 Taste sofort neu. Gehen Sie davon aus, dass alle ihre Änderungen verlorengegangen sind.");
            console.error(error);
        });
    }
}
</script>

